"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubformDuplicateTool = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const image_button_1 = require("../../../components/button/image.button");
const icons_1 = require("../../../components/icon/icons");
const notification_service_1 = require("../../../components/notification.toast/notification.service");
const i18n_1 = require("../../../i18n");
const services_1 = require("../../../services");
class SubformDuplicateTool {
    static view(collection) {
        const isMeasurementCopy = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_SUBFORM_MEASUREMENT_COPY) ||
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DUPLICATE, {
            title: isMeasurementCopy ? i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS : i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM,
            titleAttrs: { title: collection.schema.displayName },
            onclick: (e) => {
                e.stopPropagation();
                SubformDuplicateTool.duplicateSubFormInstance(collection);
            },
        });
    }
    static duplicateSubFormInstance(instance) {
        const isMeasurementCopy = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_SUBFORM_MEASUREMENT_COPY) ||
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        const newInstance = instance.parent.Mutator.copyFromInstance(instance);
        if (!newInstance) {
            notification_service_1.NotificationService.success({ key: i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS, attrs: { title: instance.title } });
            return;
        }
        // Remove all "measurements"
        newInstance === null || newInstance === void 0 ? void 0 : newInstance.forEachField((field) => {
            if (core_shared_1.CollectionModelFieldHeight.isHeightField(field) && !isMeasurementCopy) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldNumber.isNumberField(field) && !field.isManual()) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldImage.isImageField(field)) {
                field.Mutator.clear();
            }
            else if (core_shared_1.CollectionModelFieldLocation.isLocationField(field)) {
                field.Mutator.clear();
            }
        });
        notification_service_1.NotificationService.success({ key: i18n_1.T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS, attrs: { title: instance.title } });
        const label = isMeasurementCopy ? 'subform:duplicate:measurementCopy' : 'subform:duplicate';
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, label, instance.instanceId);
    }
}
exports.SubformDuplicateTool = SubformDuplicateTool;
tslib_1.__decorate([
    mobx_1.action
], SubformDuplicateTool, "duplicateSubFormInstance", null);
//# sourceMappingURL=subform.duplicate.tool.js.map